import { render } from "./ClWordRight.vue?vue&type=template&id=604dc607"
import script from "./ClWordRight.vue?vue&type=script&lang=js"
export * from "./ClWordRight.vue?vue&type=script&lang=js"

import "./ClWordRight.vue?vue&type=style&index=0&id=604dc607&lang=scss"
import "./ClWordRight.vue?vue&type=style&index=1&id=604dc607&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__